import { cn } from '@/lib/utils';
import { ButtonHTMLAttributes, forwardRef } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = 'md', ...props }, ref) => {
    return (
      <button
        className={cn(
          'inline-flex items-center justify-center rounded-full font-medium transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
          'disabled:pointer-events-none disabled:opacity-50',
          {
            'bg-[var(--color-button)] text-[var(--color-button-text)] hover:brightness-95 dark:brightness-90': variant === 'default',
            'border-2 border-[var(--color-button)] bg-white hover:bg-[var(--color-button)]/10 text-[var(--color-button)]': variant === 'outline',
            'hover:bg-[var(--color-button)]/10 text-[var(--color-button)]': variant === 'ghost',
            'h-9 px-4 text-sm': size === 'sm',
            'h-12 px-6': size === 'md',
            'h-14 px-8 text-lg': size === 'lg',
          },
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';

export { Button };